import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { buildMuiTheme, readBranding, applyCssVariables } from './brandTheme';
import { updateFaviconAndTitle } from './brandingDom';

export default function BrandThemeProvider({ children }) {
  const [branding, setBranding] = React.useState(() => readBranding());

  const theme = React.useMemo(() => buildMuiTheme(branding), [branding]);

  // Ensure CSS variables are applied on mount and when branding changes
  React.useEffect(() => {
    applyCssVariables(branding);
    updateFaviconAndTitle(branding);
  }, [branding]);

  // Listen to branding updates from the settings screen or other tabs
  React.useEffect(() => {
    const handler = () => setBranding(readBranding());
    window.addEventListener('branding:updated', handler);
    window.addEventListener('storage', handler);
    return () => {
      window.removeEventListener('branding:updated', handler);
      window.removeEventListener('storage', handler);
    };
  }, []);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
